import React, { useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import '../styling/Profile.css';

function Profile() {
  const [isHovered, setIsHovered] = useState(false);

  const profileData = {
    name: "Robin Okwanma",
    title: "Software Engineer",
    summary: "Full-stack and mobile engineer crafting production-ready fintech and consumer applications. I build scalable systems from concept to deployment—and I document the journey along the way.",
    location: "Port Harcourt, Nigeria",
    email: "robinokwanma@gmail.com",
    expertise: [
      { label: "Software Engineer", icons: "💻", description: "Web & Mobile Development" },
      { label: "Technical Writer", icons: "✍️", description: "Sharing Knowledge & Insights" },
      { label: "System Architect", icons: "🏗️", description: "Scalable Backend Systems" }
    ],
    cta: {
      resume: "Download Resume",
      contact: "Let's Connect"
    }
  };

  return (
    <section className="profile-section">
      <Container className="profile-container">
        <Row className="profile-row align-items-center justify-content-between g-0">
          
          {/* Left Column - Text Content */}
          <Col lg={6} md={12} className="profile-content">
            <div className="profile-greeting">
              <span className="greeting-accent">Welcome,</span>
              <h1 className="profile-name">
                I'm <span className="name-highlight">Robin</span>.
              </h1>
              <div className="name-underline"></div>
            </div>

            <p className="profile-summary">
              {profileData.summary}
            </p>

            {/* Expertise List */}
            <div className="expertise-list">
              {profileData.expertise.map((item, idx) => (
                <div key={idx} className="expertise-item">
                  <span className="expertise-icon">{item.icons}</span>
                  <div className="expertise-text">
                    <div className="expertise-label">{item.label}</div>
                    <div className="expertise-description">{item.description}</div>
                  </div>
                </div>
              ))}
            </div>

          {/* CTA Buttons */}
          <div className="cta-section">
            <a 
              href="/resume/Robinresume.pdf" 
              download="Robin_Okwanma_Resume.pdf"
              className="btn-primary-custom"
            >
              <span className="btn-icon">📥</span>
              {profileData.cta.resume}
            </a>
            <a href={`mailto:${profileData.email}`} className="btn-secondary-custom">
              <span className="btn-icon">✉️</span>
              {profileData.cta.contact}
            </a>
          </div>

            {/* Contact Info */}
            <div className="contact-info">
              <p className="info-text">
                <span className="info-icon">📍</span>
                {profileData.location}
              </p>
              <p className="info-text">
                <span className="info-icon">📧</span>
                <a href={`mailto:${profileData.email}`}>{profileData.email}</a>
              </p>
            </div>
          </Col>

          {/* Right Column - Image */}
          <Col lg={6} md={12} className="profile-image-section">
            <div 
              className="profile-image-wrapper"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <div className="image-container">
                <img 
                  src="images/robinokwanma.jpg" 
                  alt="Robin Okwanma - Software Engineer" 
                  className="profile-image"
                />
              </div>
              
              {/* Floating Badge */}
              <div className="floating-badge">
                <span className="badge-emoji">⭐</span>
                <div className="badge-content">
                  <div className="badge-label">Top Rated Plus</div>
                  <div className="badge-value">20+ Projects Completed.</div>
                </div>
              </div>

              {/* Glow Effect */}
              <div className={`image-glow ${isHovered ? 'active' : ''}`}></div>
            </div>
          </Col>
        </Row>

        {/* Stats Section */}
        <div className="stats-section">
          <div className="stat-item">
            <div className="stat-value">5+</div>
            <div className="stat-label">Years Experience</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-value">15+</div>
            <div className="stat-label">Projects Delivered</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-value">100%</div>
            <div className="stat-label">Client Satisfaction</div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default Profile;